const TEAM_PREFIX_REGEX = /^\/t\/([^/?#]+)(.*)?$/;

// Appointment numbers are generated server-side as `<TEAM_KEY>-<sequence>`.
// The API constrains team keys to uppercase alphanumerics — managed-care-api
// SentinelTeam validates team_key against /\A[A-Z0-9]*\z/ — so the prefix of a
// real appointment number is always [A-Z0-9]. A bare appointment/service-event
// deep link therefore encodes its owning team in the number, letting us route
// to the correct team instead of defaulting to the user's current one.
const RESOURCE_NUMBER_PATH_REGEX =
  /^\/(?:appointments|service_events)\/([A-Z0-9]+)-\d+/;

export function getTeamKeyFromPath(pathname: string): string | null {
  const match = pathname.match(TEAM_PREFIX_REGEX);
  return match ? match[1] : null;
}

export function getTeamKeyFromResourceNumber(pathname: string): string | null {
  const match = pathname.match(RESOURCE_NUMBER_PATH_REGEX);
  return match ? match[1] : null;
}

export function buildTeamPath(teamKey: string, path = '/'): string {
  return `/t/${teamKey}${path}`;
}

export function stripTeamPrefix(pathname: string): string {
  const match = pathname.match(TEAM_PREFIX_REGEX);
  if (!match) return pathname;
  const rest = match[2] || '';
  // If the rest starts with / it's a sub-path – return as-is.
  // Otherwise it starts with ? or # (or is empty) – prepend / so the
  // caller always gets an absolute inner path.
  return rest.startsWith('/') ? rest : `/${rest}`;
}
